module.exports = function(media) {
	"use strict";
  media
  .controller('libraryController', libraryController);
	libraryController.$inject = ["downloadImage","watchAllCheckboxesNgTable","$http","cleanObj","API_URL","authtokenService","postDataService","$timeout","$stateParams","$state","config","$scope","$rootScope","NgTableParams","getDataService","jQuery","refreshtokenService","$compile","putDataService","alertService","serverError","keyPressOnlyNumber","offlineError"];
	
  function libraryController(downloadImage,watchAllCheckboxesNgTable,$http,cleanObj, API_URL,authtokenService,postDataService,$timeout,$stateParams,$state,config,$scope,$rootScope,NgTableParams,getDataService,jQuery,refreshtokenService,$complie,putDataService,alertService,serverError,keyPressOnlyNumber,offlineError) {
    var vml = this;
    vml.config = config;
    $rootScope.emptyTable = false;
    vml.editMediaModalShow = false;
    vml.showGrid = false;
    vml.selectedImage = -1;
    vml.editMediaShow = false;
    vml.selectedMediatoEdit = 0;
    var state = 'attachments';
    var page = 1;
    var author;
    var date_start;
    var date_end;
    var sortby ='date';
    var s;
    var uploaded_to;
    var unattached;
    var $data;
    vml.status = 'all';
    vml.checkedTypeSearch =false;
    vml.selectedDesccription = -1;
    // vml.selectedMediaAction = {value: 'default'};
    vml.selectedAuthorFilter = {value: 'all'};
    vml.selectedBulkAction = {value: 'default'};
    vml.checkedPostsEdit = [];
    vml.hiddenBulkEdit = true;
    vml.checkboxes = { 'checked': false, items: {} };
    vml.cropModalShow = false;
    vml.mediaItemToCrop = {};
    vml.attachToPostModalShow = false;
    vml.uploadApprovalRestrictionsModal = false;
    vml.attachtoPost_id = null;
    vml.attachmentId = $stateParams.id;
    vml.checkedPostsforAttach = [];
    vml.checkedPostsforDetach = []; 
    if($stateParams.id) {
      vml.editMediaShow = true;
    } else {
      vml.editMediaShow = false;
    }
    vml.downloadImage = downloadImage;
    $scope.ranges = {
      'Today': [moment().startOf('day'), moment()],
      'Yesterday': [moment().subtract('days', 1).startOf('day'), moment().subtract('days', 1).endOf('day')],
      'Last 7 days': [moment().subtract('days', 7), moment()],
      'Last 30 days': [moment().subtract('days', 30), moment()],
      'This month': [moment().startOf('month'), moment().endOf('month')],
      'All days':[moment().subtract('year',5),moment()]
    };
    vml.onlyNumber = function(event) {
      keyPressOnlyNumber(event) 
    }
    vml.changeDateRestrictions = function(value) {
      vml.dateRangevalueRestrictions = value;
      if(vml.dateRangevalueRestrictions) {
        if(value.startDate && value.endDate) {
          vml.date_start_restrictions = value.startDate.format('YYYY-MM-DD');
          vml.date_end_restricitons = value.endDate.format('YYYY-MM-DD');
        } else {
          vml.date_start_restrictions = null;
          vml.date_end_restricitons = null;
        }
      } else {
          vml.date_start_restrictions = null;
          vml.date_end_restricitons = null;
      }
    }
    angular.element(document).on('mouseup', function(e) {
      var container = angular.element(document.getElementsByClassName("grid"));
      var media_modal = angular.element(document.getElementsByClassName("media-modal"));
      
      if (!container.is(e.target) // if the target of the click isn't the container...
        && container.has(e.target).length === 0 && vml.showGrid && !media_modal.is(e.target) && media_modal.has(e.target).length===0) // ... nor a descendant of the container
      {
        $scope.$apply(function () {
          vml.selectedImage = -1;
        });
      }
    });
    vml.purgeCache = function(filepath) {
      if(!filepath) return;
      $rootScope.hasLoaded = false;
      var postFunction = function() {
        postDataService.save({
          param1:state,
          param2:'purgeVarnish'
        },{
          'filepath': filepath
        }).$promise.then(function(data){
          $rootScope.hasLoaded = true;
          alertService('success','Success ', data.message, 2000);
        }, function(error){
          if(!window.navigator.onLine) {
            offlineError()
            $rootScope.hasLoaded = true;
            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
            return
          }
          if(error.status ==401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
            function(answer) {
              if(answer==200) {
              postFunction();
              }
            },
            function(error) {
              // report something
            },
            function(progress) {
              // report progress
            });
          } else if(error.status ==502) {
            serverError()
          } else {
            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
          }
          $rootScope.hasLoaded = true;
        });
      }
      postFunction()
    }
    function changeMediaStatus(postIds, param) {
      if(!postIds) return;
      $rootScope.hasLoaded = false;
      postDataService.save({
        param1:state,
        param2:'status',
        param3:param
      },{
        'ids': postIds,
      }).$promise.then(function(data){
        $rootScope.hasLoaded = true;
        vml.checkedPostsforLockOrUnlock = [];
        watchAllCheckboxesNgTable.resetCheckBox(vml) 
        alertService('success','Success ', data.message, 2000);
        vml.tableParams.reload();
      }, function(error){
        if(!window.navigator.onLine) {
          offlineError()
          $rootScope.hasLoaded = true;
          alertService('danger','Opps! ', 'Please check your internet connection and try again.');
          return
        }
        if(error.status ==401) {
          var promise = refreshtokenService.getAccessToken();
          promise.then(
            function(answer) {
              if(answer==200) {
                changeMediaStatus(postIds, param);
              }
            },
            function(error) {
              // report something
            },
            function(progress) {
             // report progress
          });
        } else if(error.status ==502) {
          serverError()
        } else {
          console.log(error)
          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
        }
        $rootScope.hasLoaded = true;
      });
    }
    vml.changeMediaStatus = function(postId,param) {
      changeMediaStatus([postId], param)
    }
    // vml.getPdf = function(postItem) {
    //   var token = authtokenService.getToken();
    //   var getPdfFunction = function() {
    //   var req = new XMLHttpRequest();
    //   var filename = postItem._id + '-approval.pdf';
    //     req.open("GET", postItem.approval_url, true);
    //     req.setRequestHeader('x-auth', token)
    //     req.responseType = "blob";
    //     req.onload = function (event) {
    //         var blob = req.response;
    //         var link=document.createElement('a');
    //         link.href=window.URL.createObjectURL(blob);
    //         link.style = "display: none";
    //         document.body.appendChild(link);  
    //         link.download=filename;
    //         link.click();
    //         setTimeout(function(){
    //           document.body.removeChild(link);
    //         },0)
    //     };
    //     req.send();
    //   }
    //   getPdfFunction();
    // }
    var detachFunction = function() {
      postDataService.save({
        param1:state,
        param2:'detach'
      },{
        'ids': vml.checkedPostsforDetach,
      }).$promise.then(function(data){
          vml.checkedPostsforDetach = [];
          watchAllCheckboxesNgTable.resetCheckBox(vml)
          vml.selectedBulkAction = {value: 'default'}; 
          alertService('success','Success ', data.message, 2000);
          vml.tableParams.reload();
      }, function(error){
        if(!window.navigator.onLine) {
          offlineError()
          alertService('danger','Opps! ', 'Please check your internet connection and try again.');
          return
        }
        if(error.status ==401) {
          var promise = refreshtokenService.getAccessToken();
          promise.then(
            function(answer) {
              if(answer==200) {
                detachFunction();
              }
            },
            function(error) {
              // report something
            },
            function(progress) {
             // report progress
          });
        } else if(error.status ==502) {
          serverError()
        } else {
          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
        }
        vml.checkedPostsforDetach = [];
        watchAllCheckboxesNgTable.resetCheckBox(vml)
        vml.selectedBulkAction = {value: 'default'}; 
      });
    }
    vml.detach = function(attachment_id) {
      if(attachment_id) {
        vml.checkedPostsforDetach = [attachment_id];
        detachFunction();
      }
    }
    vml.attachToPost = function(attachment_id) {
      if(attachment_id) {
        vml.checkedPostsforAttach = [attachment_id];
        vml.attachToPostModalOpen();
      }
    }
    vml.attachToPostModalOpen = function() {
      vml.attachToPostModalShow = true;
      $rootScope.modalShow = true;
    }
    vml.cancelAttachToPostModal = function() {
      vml.attachToPostModalShow = false;
      vml.checkedPostsforAttach = [];
      $rootScope.modalShow = false;
      watchAllCheckboxesNgTable.resetCheckBox(vml)
      vml.selectedBulkAction = {value: 'default'};
      // vml.tableParams.reload(); 
    }
    vml.openCropModal = function(post) {
        vml.cropModalShow = true;
        vml.mediaItemToCrop.featured_img_obj = post;
        vml.mediaItemToCrop.featured_img_id = post._id; 
        // vml.mediaItemToCrop.featured_img = post.thumbs['830x0'];
        // vml.mediaItemToCrop.featured_img_width = post.meta.width;
        // vml.mediaItemToCrop.featured_img_height = post.meta.height;
        // vml.mediaItemToCrop.featured_img_thumbs = post.thumbs;
        $rootScope.modalShow = true;
    }
    vml.mediaItemToCrop.cancelCropModal = function() {
      vml.cropModalShow = false;
      $rootScope.modalShow = false;
    }
    vml.editMedia = function(attachmentId) {
      jQuery("html, body").animate({
        scrollTop: 0
      }, 600);
      vml.attachmentId = attachmentId;
      vml.editMediaShow = true;
      $state.transitionTo('app.library', {id: vml.attachmentId}, {
        location: true,
        inherit: true,
        relative: $state.$current,
        notify: false
      });
    }
    vml.editMediaModal = function(index,media_id) {
      vml.editMediaModalShow = true;
      vml.selectedImage = index;
      vml.selectedMediatoEdit = index;
      vml.attachmentId = media_id;
      // $scope.$broadcast("editMediaModal", {mediaIndex:index});
    }
    vml.cancelMediaModal = function() {
      vml.editMediaModalShow = false;
      vml.selectedMediatoEdit = 0;
      vml.attachmentId = null;
      $rootScope.modalShow = false;
    }
    vml.getGrid = function() {
      var grid_wrapp = angular.element(document.getElementsByClassName("grid-wrapper"));
      var table = angular.element(document.getElementsByClassName("table"));
      table.after(grid_wrapp);    
    }
    vml.goToEditPost = function(post_id) {
      $rootScope.mediaComunicateWithEditPost = post_id;
      $state.go('app.allposts');
    }
    var deleteFunction = function() {
      putDataService.update({
        param1:state, 
        param2: 'bulk',
        param3:'delete'
        },{
          'delete_ids':vml.checkedPostsforDelete,
        }).$promise.then(function(bulkDelete){
          $rootScope.hasLoaded = true;
          vml.checkedPostsforDelete = [];
          watchAllCheckboxesNgTable.resetCheckBox(vml)
          vml.selectedBulkAction = {value: 'default'}; 
          alertService('success','Success ', bulkDelete.message, 2000);
          vml.tableParams.reload();
      }, function(error){
        if(!window.navigator.onLine) {
          offlineError()
          $rootScope.hasLoaded = true;
          alertService('danger','Opps! ', 'Please check your internet connection and try again.');
          return
        }
        if(error.status ==401) {
          var promise = refreshtokenService.getAccessToken();
          promise.then(
            function(answer) {
              if(answer==200) {   
                deleteFunction();
              }
            },
            function(error) {
              // report something
            },
            function(progress) {
             // report progress
          });
        }else if(error.status ==502) {
          serverError();
        } else {
          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
        }
        $rootScope.hasLoaded = true;
        vml.checkedPostsforDelete = [];
        watchAllCheckboxesNgTable.resetCheckBox(vml)
        vml.selectedBulkAction = {value: 'default'};   
      });
    }
    vml.uploadApprovalRestrictions = function() {
      vml.uploadApprovalRestrictionsModal = true;
      $rootScope.modalShow = true;
    }
    vml.cancelUploadApprovalRestrictionsModal = function() {
      vml.uploadApprovalRestrictionsModal = false;
      // vml.checkedPostsforRestrictions = [];
      $rootScope.modalShow = false;
      watchAllCheckboxesNgTable.resetCheckBox(vml)
      vml.selectedBulkAction = {value: 'default'};
      // vml.tableParams.reload(); 
    }
    vml.deletePosts = function(post_id) {
      $rootScope.hasLoaded = false;
      vml.checkedPostsforDelete = [];
      vml.checkedPostsforDelete.push(post_id)
      deleteFunction();  
    }
    vml.bulkAction = function(param) {
      vml.checkedPostsforDelete = []
      vml.addRestrictions = false;
      if(param == "edit" && vml.checkedPostsEdit.length > 0) {
        vml.hiddenBulkEdit =false;
      } else if(param == 'addRestrictions' && vml.checkedPostsEdit.length>0){
        vml.hiddenBulkEdit =false;
        vml.addRestrictions = true;
      }else if(param == 'removeRestrictions' && vml.checkedPostsEdit.length>0){
        $timeout(function() {
          vml.updateBulkAction('remove-restrictions')
        },0)
      } else if (param == 'delete' && vml.checkedPostsEdit.length>0 ) {
        vml.hiddenBulkEdit =true;
        for(var i=0;i<vml.checkedPostsEdit.length;i++) {
          vml.checkedPostsforDelete.push(vml.checkedPostsEdit[i]._id);
        }
        deleteFunction(param == 'delete' && vml.checkedPostsEdit.length>0);
      } else if(param == 'attach' && vml.checkedPostsEdit.length>0) {
        for(var i=0;i<vml.checkedPostsEdit.length;i++) {
          vml.checkedPostsforAttach.push(vml.checkedPostsEdit[i]._id);
        }
        $timeout(function() {
          vml.attachToPostModalOpen();
        },0)
      } else if(param == 'detach' && vml.checkedPostsEdit.length>0) {
        for(var i=0;i<vml.checkedPostsEdit.length;i++) {
          vml.checkedPostsforDetach.push(vml.checkedPostsEdit[i]._id);
        }
        $timeout(function() {
          detachFunction();
        },0)
      } else if(param == 'uploadApprovalRestrictions' && vml.checkedPostsEdit.length>0) {
        // vml.checkedPostsforRestrictions = [];
        // console.log(vml.checkedPostsEdit)
        // for(var i=0;i<vml.checkedPostsEdit.length;i++) {
        //   vml.checkedPostsforRestrictions.push(
        //     {
        //       '_id' : vml.checkedPostsEdit[i]._id
        //     }
        //   );
        // }
        vml.uploadApprovalRestrictions();
      } else if ((param == 'publish' && vml.checkedPostsEdit.length>0) || (param=='lock' && vml.checkedPostsEdit.length>0)) {
        vml.checkedPostsforLockOrUnlock = []
        for(var i=0;i<vml.checkedPostsEdit.length;i++) {
          vml.checkedPostsforLockOrUnlock.push(vml.checkedPostsEdit[i]._id);
        }
        changeMediaStatus(vml.checkedPostsforLockOrUnlock, param)
      }
    }
    watchAllCheckboxesNgTable.watch($scope,vml,true)
    vml.checkedPost = function(checked,post) {
      if (checked) {
        vml.checkedPostsEdit.push(post);
      } else {
       vml.checkedPostsEdit = vml.checkedPostsEdit.filter(function( obj ) {
            return obj._id !== post._id;
        });
      } 
    }
    vml.removeEditPost = function(post_id) {
      vml.checkedPostsEdit = vml.checkedPostsEdit.filter(function( obj ) {
            return obj._id !== post_id;
      });
      vml.checkboxes.items[post_id] = false;
      if(!vml.checkedPostsEdit.length > 0) {
        vml.cancelBulkEdit();
      }
    }
    vml.cancelBulkEdit =function() {
      vml.hiddenBulkEdit = true;
      vml.addRestrictions = false;
      vml.myDateRangeRestrictions = '';
      vml.numberOfUsesRestrictions = null;
      vml.date_start_restrictions = null;
      vml.date_end_restricitons = null;
      vml.checkboxes.checked= false;
      vml.bulkTitle = '';
      vml.bulkGalleryTitle = '';
      vml.bulkDescription = '';
      vml.bulkSignature = '';
      vml.bulkSignatureUrl = '';
      vml.lockPhoto = false;
      vml.selectedBulkAction={value:'default'};
      vml.checkedPostsforUpdate = [];
      
    }
    vml.updateBulkAction = function(param) {
      vml.checkedPostsforUpdate = [];
      for(var i = 0; i<vml.checkedPostsEdit.length;i++) {
        vml.checkedPostsforUpdate.push(vml.checkedPostsEdit[i]._id)
      }
      if(vml.checkedPostsforUpdate.length==0) return
      if(param == 'remove-restrictions') {
        var updateData = { 
          'ids': vml.checkedPostsforUpdate,
          'remove_restrictions': true
        }
      } else {
        if(vml.addRestrictions) {
          if(!vml.numberOfUsesRestrictions && !vml.date_start_restrictions) {
            alertService('danger','Opps! ', 'You have to fill at least one field');
            return
          }
          var updateData = { 
            'ids': vml.checkedPostsforUpdate,
            'restrictions':{
              date_from :  (vml.date_start_restrictions)? vml.date_start_restrictions: undefined,
              date_to :  (vml.date_end_restricitons)? vml.date_end_restricitons: undefined,
              use_max : (vml.numberOfUsesRestrictions)? parseInt(vml.numberOfUsesRestrictions) : undefined
            }
          }
        } else {
          if(!vml.bulkTitle && !vml.bulkSignature && !vml.bulkDescription && !vml.bulkSignatureUrl && !vml.lockPhoto && !vml.bulkGalleryTitle) {
            alertService('danger','Opps! ', 'You have to fill at least one field');
            return
          }
          var updateData = {
            'ids': vml.checkedPostsforUpdate,
            'title': (vml.bulkTitle)? vml.bulkTitle:undefined,
            'gallery_title': (vml.bulkGalleryTitle)? vml.bulkGalleryTitle:undefined,
            'signature': (vml.bulkSignature)? vml.bulkSignature:undefined,
            'signature_url': (vml.bulkSignatureUrl)? vml.bulkSignatureUrl:undefined,
            "description": (vml.bulkDescription)? vml.bulkDescription:undefined,
            'restrictions': (vml.lockPhoto)? {'use_max': 0 }: undefined  
          }
        }
      }
      $rootScope.hasLoaded = false;
      var postFunction = function() { 
        postDataService.save({
          param1:state,
          param2:'multi-update'
        },updateData).$promise.then(function(data){
          alertService('success','Success ', data.message, 2000);
          $rootScope.hasLoaded = true;
          vml.cancelBulkEdit();
          vml.tableParams.reload();
        }, function(error){
          if(!window.navigator.onLine) {
            offlineError()
            $rootScope.hasLoaded = true;
            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
            return
          }
          if(error.status ==401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                if(answer==200) {
                  postFunction();
                }
              },
              function(error) {
                // report something
              },
              function(progress) {
                // report progress
            });
          } else if(error.status ==502) {
            serverError()
          } else {
            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
          }
          $rootScope.hasLoaded = true;
          vml.cancelBulkEdit();
        });
      }
      postFunction();
    }
    vml.editDescription = function(index) {
      vml.selectedDescription = index;
    }
    vml.cancelEditDescription = function() {
      vml.selectedDescription = -1;
    }
    vml.changeSearch = function(search_data) {
      if(search_data) {
        s = search_data;
      } else {
        s = null;
        vml.checkedTypeSearch = false;
        $timeout(function() {
          vml.search();
        },0)            
      }
    }
    vml.switchAuthorFilter = function(item) {
        author = item;
        if (item=='all') {
          author = null;
        }
    }
    vml.changeDate = function(value) {
      vml.dateRangevalue= value;
      if(vml.dateRangevalue) {
        if(value.startDate && value.endDate) {
          date_start = value.startDate.format('YYYY-MM-DD');
          date_end = value.endDate.format('YYYY-MM-DD');
        } else {
          date_start = null;
          date_end = null;
        }
      } else {
        date_start = null;
        date_end = null;
      }
    }
    var getAuthorsFunction = function() {
      getDataService.get({param1:'users', param2: 'all'}).$promise.then(function(data){      
        vml.authorList = data.users;
      }, function(error){
        if(!window.navigator.onLine) {
          offlineError()
          return
        }
        if(error.status == 401) {
          var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                if(answer==200) {
                  getAuthorsFunction();
                }
              },
              function(error) {
                // report something
              },
              function(progress) {
               // report progress
              });
        } else if(error.status ==502) {
          serverError()
        }else {
          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
        }
      });
    }
    getAuthorsFunction();
    var reloadTableFunction = function() {
      if(vml.tableParams.page() ==1) {
        vml.tableParams.reload();
      } else {
        vml.tableParams.page(1);
      }
    } 
    vml.mediaFilters = function() {
      reloadTableFunction();
    }
    vml.resetAllFilters = function() {
      vml.status = 'all';
      uploaded_to = null;
      vml.searchData = null;
      s =null;
      author = null;
      vml.selectedAuthorFilter = {value: 'all'};
      date_start = null;
      date_end = null;
      $scope.$broadcast('clear-daterange',true);
      vml.checkedTypeSearch = false;
      reloadTableFunction();
    }
    vml.authorPosts = function(value) {
      author = value;
      reloadTableFunction();
    }
    vml.uploadeToPost = function(uploadedTo) {
      uploaded_to = uploadedTo;
      reloadTableFunction();
    }
    vml.changeStatus =function(event,activeStatus) {
      vml.status = activeStatus;
      if(activeStatus =='all') {
        uploaded_to = null;
      } else {
        uploaded_to = activeStatus;
      }
      reloadTableFunction();
    }
    vml.search =function(value) {
      if(value) {
        s = value.toLowerCase();
      } else {
        vml.checkedTypeSearch = false;
        s = null;
      }
      reloadTableFunction();
    }
    vml.tableReloadFunction = function(page) { 
      vml.tableParams = new NgTableParams({
          page: page || 1,
          count: 20,
        }, {
        getData: function(params) {
          $rootScope.hasLoaded = false;
          return getDataService.get({
            param1: state,
            param2: null,
            page: params.page(),
            limit: params.count(),
            author: author,
            s:s,
            type:(vml.checkedTypeSearch && s)? 'all':undefined,
            uploaded_to:uploaded_to,
            sortby: $rootScope.sortby,
            sort : $rootScope.sort,
            date_start: date_start,
            date_end: date_end
            }).$promise.then(function(data){
              $rootScope.hasLoaded = true;
              vml.dataGet = data.attachments;
              vml.data_grid =data.attachments;
              $data =data.attachments;
              $rootScope.emptyTable = false;
              watchAllCheckboxesNgTable.resetCheckBox(vml)
              vml.cancelBulkEdit();  
              params.total(data.count);
              params.numPages(data.max_pages);
              jQuery('.goTo input').val("");
              if(vml.showGrid){
                $timeout(function() {
                  vml.getGrid();
                },0)
              }
              return $data;
            }, function(error){
              if(!window.navigator.onLine) {
                $rootScope.hasLoaded = true;
                offlineError('refresh')
                return
              }
              if(error.status ==401) {
                var promise = refreshtokenService.getAccessToken();
                promise.then(
                  function(answer) {
                    if(answer==200) {
                      vml.tableReloadFunction(params.page());
                    }
                    // do something
                  },
                  function(error) {
                  },
                  function(progress) {
                   // report progress
                  });
              } else if(error.status ==404) {
                $rootScope.emptyTable = true;
              } else if(error.status ==502) {
                serverError();
              } else {
                alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
              }
              $rootScope.hasLoaded = true; 
            });
          }    
      });
    }
    vml.tableReloadFunction();
    if(!window.navigator.onLine) {
      offlineError('refresh')
      return
    }
  }	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/mediaModule/library/js/libraryController.js
// module id = 519
// module chunks = 0